import { ContentfulLeaderboardBanner } from '@jbhi-fi/apis/src/contentful/types';
import { HeroBannerProps } from '../../HeroBanner/HeroBanner';
import { ContentfulImage } from '../../ContentfulImage/ContentfulImage';
import { AssetTransformer } from './AssetTransformer';
import React from 'react';
import { CollectionLeaderboardBannerProps } from '../../CollectionLeaderboardBanner/CollectionLeaderboardBanner';

export abstract class LeaderboardBannerTransformer {
  static toHeroBannerProps = (
    entry?: ContentfulLeaderboardBanner,
    testId?: string,
    variant?: string,
    isHeroBanner?: boolean
  ): HeroBannerProps => {
    return {
      variant: variant as 'homepage' | 'collection' | undefined,
      isHeroBanner: isHeroBanner,
      testId: testId,
      href: entry?.fields?.urllink ?? '',
      image: entry?.fields?.desktopLeaderboard?.fields ? (
        <ContentfulImage
          {...AssetTransformer.toContentfulImageProps(entry?.fields?.desktopLeaderboard)}
          height={220}
          width={1124}
        />
      ) : null,
      imageMobile: entry?.fields?.mobileLeaderboard?.fields ? (
        <ContentfulImage
          {...AssetTransformer.toContentfulImageProps(entry?.fields?.mobileLeaderboard)}
          height={400}
          width={343}
        />
      ) : null,
      trackingData: {
        id: entry?.fields?.name ?? '',
        url: entry?.fields?.urllink,
        position: 0,
        type: 'leaderboard',
        brand: entry?.fields?.brand,
      },
    };
  };

  static toCollectionLeaderboardBannerProps = (
    leaderboard?: {
      entry: ContentfulLeaderboardBanner;
      category: string;
    },
    index?: number
  ): CollectionLeaderboardBannerProps => {
    return {
      href: leaderboard?.entry?.fields?.urllink ?? '',
      desktopImage: (
        <ContentfulImage
          {...AssetTransformer.toContentfulImageProps(leaderboard?.entry?.fields?.desktopLeaderboard)}
          isProgressive={false}
        />
      ),
      mobileImage: (
        <ContentfulImage
          {...AssetTransformer.toContentfulImageProps(leaderboard?.entry?.fields?.mobileLeaderboard)}
          isProgressive={false}
        />
      ),
      trackingData: {
        name: leaderboard?.entry?.fields?.name ?? '',
        brand: leaderboard?.entry?.fields?.brand ?? '',
        category: leaderboard?.category ?? '',
        index: index,
      },
    };
  };
}
